



import LiveListComponent from "@/components/admin/live/liveListComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "LiveListPage",
  components: {
    LiveListComponent,
  },
})
export default class LiveListPage extends Vue {}
